import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { columns, MobileColumnDataGrid } from "./columns.js";
import {
  selectDefultProfileSetting,
  selectLatitude,
  selectLongitude,
  selectPrefix,
  selectWidth,
} from "../utility/Redux/profile.js";
import {
  editBillFields,
  GetListItemMaster,
  LoadBill,
  onBillSave,
  SectionlistUI,
  itemClick,
  listSectionMasterApi,
} from "./function.js";
import { selectToken } from "../utility/Redux/security.js";
import moment from "moment";
import AccountMasterHelp from "../help/listAccountMasterHelp.js";
import AlertModalTwoButton from "../utility/component/modals/alertWithTwoButton.js";
import { selectSectionList } from "../utility/Redux/list.js";
import ViewBillModal from "./viewBillModal.js";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import {
  selectIssueItem,
  setAlertWithTitle,
  setnumericKeyboardStatus,
  setSpinnerLoading,
} from "../utility/Redux/modal.js";
import ModNumericKeyboard from "../utility/component/modalNumeric.js";
import { useFocus } from "../utility/hooks/hooks.js";
import BarcodeScanner from "../utility/component/barcodeScanner.js";
import { fastMovingMovieItem } from "../utility/constant.js";
import {
  billCart,
  BillNoComp,
  orderTypeList,
  searchItemInput,
  totalQntyComponent,
} from "./common.js";
import deleteWholeDatabase from "../utility/functions/deleteWholeDatabase.js";
import dataToLocal from "../utility/component/dataToLocal.js";
import { useLocation, useNavigate } from "react-router-dom";
import ItemInstructionModal from "./itemInstruction.js";

import BillingSettingsModal from "./settingModal.js";
import StockHelp from "../help/stockHelp.js";
import MobileStockOrdering from "./mobileScreens.js";
import OrderReceiptModal from "./printOrderBill.js";
import ItemSelectModal from "./itemModal.js";

const StockOrdering = () => {
  const width = useSelector(selectWidth);
  const previosInstruction = localStorage.getItem("item_instruction")
    ? JSON.parse(localStorage.getItem("item_instruction"))
    : [];
  const [settingModalStatus, setSettingModalStatus] = useState(false);

  const location = useLocation();
  const [printData, setPrintData] = useState([]);
  const naviagte = useNavigate();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const [Item_Box, setItem_Box] = useState("");
  const [isRemove0Active, setIsRemove0Active] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [itemHelpStatus, setItemHelpStatus] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [remarksStatus, setRemarksStatus] = useState(false);
  const [searchQnty, setSearchQnty] = useState(1);
  const [itemImgList, setItemImgList] = useState([]);
  const [viewBillStatus, setViewBillStatus] = useState(false);
  const dispatch = useDispatch();
  const [isHoldButtonShow, setIsHoldButonShow] = useState(true);
  const [isTextActive, setisTextActive] = useState(false);
  const [salepriceModalStatus, setSalePriceModalStatus] = useState(false);
  const [searchRef, setSearchFocus] = useFocus();
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [billCartList, setBillCartList] = useState([]);
  const [sectionName, setSectionName] = useState("");
  const sectionList = useSelector(selectSectionList);
  const [isOriginalBill, setIsOriginalBill] = useState(false);
  const [listAccountMasterHelp, setListAccountMasterHelp] = useState(false);
  const [isSectionDrawerOpen, setIsSectionDraweropen] = useState(false);
  const [billHelpStatus, setBillHelpStatus] = useState(false);
  const [billNo, setBillNo] = useState("");
  const [accountdetails, setAccountDetails] = useState({
    ACCOUNT_NO: "",
    ACCOUNT_NAME: "",
  });
  const [grandTotalWithTax, setGrandTotalWithTax] = useState(0);
  const [barCodeCannerStatus, setBarCodeScannerStatus] = useState(false);
  const [roundOffAmt, setRoundOffAmt] = useState(0);
  const longitude = useSelector(selectLongitude);
  const latitude = useSelector(selectLatitude);

  const bill_performa = "bills";
  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: "",
    msg: "",
    status: false,
    setStatus: "",
    button1: "",
    button1Click: "",
    button2: "",
    button2Click: "",
  });
  const [currentItemsPage, setCurrentItemPage] = useState(1);
  const [orderType, setOrdertype] = useState(orderTypeList[0].value);
  const [totalItemsPage, setTotalItemsPage] = useState(1);
  const profileSetting = useSelector(selectDefultProfileSetting);
  const emptyCustomer = {
    CUSTOMER_NAME: "",
    CUSTOMER_ADDRESS: "",
    CUSTOMER_MOBILE: "",
    CUSTOMER_EMAIL: "",
    CUSTOMER_TYPE: "",
    CITY: "",
    COUNTRY: "",
    PIN_CODE: "",
    DISQ_RATE: "",
    LOYALTY_POINTS: 0,
    CUSTOMER_STATUS: "Active",
    PRV_BAL: 0,
    BAL_TYPE: "",
    CUSTOMER_CODE: "",
  };
  const [customerDetails, setCustomerDetails] = useState(emptyCustomer);
  const emptyBillingDetails = {
    mobile: "",
    customerName: "",
    cashAmount: 0,
    cardAmount: 0,
    cardNo: "",
    eAmount: 0,
    btcAmount: 0,
    btcName: "",
    couponAmount: 0,
    couponNo: "",
    HANDLING_CHARGES: 0,
    DELIVERY_CHARGES: 0,
  };

  const [billingDetails, setBillingDetails] = useState(emptyBillingDetails);
  const [SaleType, setSaleType] = useState("");
  const [isStockCheck, setIsStockCheck] = useState("Yes");
  useEffect(() => {
    setSaleType(profileSetting?.SALE_TYPE);
    setIsStockCheck(profileSetting?.CHECK_STOCK === "No" ? false : true);
  }, [profileSetting]);
  const [itemSearchText, setItemSearchText] = useState("");
  const [itemList, setItemList] = useState([]);
  const c = columns(
    width,
    setBillCartList,
    setAlertTwoButtonModal,
    setRemarksStatus,
    setSelectedItem
  );

  useEffect(() => {
    if (!sectionList[0] && navigator.onLine) {
      listSectionMasterApi(prefix, token, "", dispatch);
    }
  }, []);

  const TotalQnty = billCartList.reduce(
    (acc, row) => acc + Number(row.QNTY),
    0
  );
  const returnItem = billCartList.filter((e) => e.RQNTY > 0);
  const TotalAmount = billCartList.reduce(
    (acc, row) => acc + row.NET_AMOUNT,
    0
  );

  const totalReturn = billCartList.reduce(
    (acc, row) => acc + Number(row.RQNTY),
    0
  );

  const totalReturnAmount = returnItem.reduce(
    (acc, row) => acc + row.NET_AMOUNT,
    0
  );

  const Undo = () => {
    setCustomerDetails({
      CUSTOMER_NAME: "",
      CUSTOMER_ADDRESS: "",
      CUSTOMER_MOBILE: "",
      CUSTOMER_EMAIL: "",
      CUSTOMER_TYPE: "",
      CITY: "",
      COUNTRY: "",
      PIN_CODE: "",
      DISQ_RATE: "",
      LOYALTY_POINTS: 0,
      CUSTOMER_STATUS: "Active",
      PRV_BAL: 0,
      BAL_TYPE: "",
    });
    setBillingDetails(emptyBillingDetails);
    setBillCartList([]);
    setSearchFocus();
    setItemSearchText("");
    setSectionName("");
    setIsHoldButonShow(true);
  };

  const issueItemDetails = useSelector(selectIssueItem);

  const fromref = useRef(null);
  const searchBoxRef = useRef(null);
  const inputFields = fromref?.current?.querySelectorAll("input, select");
  const searchBoxInuptRef = searchBoxRef?.current?.querySelectorAll("input");

  const isVoided = (I) => {
    const l = billCartList.filter((s) => s.ICODE === I.ICODE && s.RQNTY > 0);
    if (l[0]) {
      return {
        backgroundColor: "#FAA8A8",
        color: "black",
      };
    } else {
      return false;
    }
  };
  useEffect(() => {
    GetListItemMaster(
      prefix,
      fastMovingMovieItem,
      token,
      dispatch,
      "",
      "",
      setItemList,
      currentItemsPage,
      setTotalItemsPage
    ).then((list) => {
      if (!list[0]) {
        GetListItemMaster(
          prefix,
          "",
          token,
          dispatch,
          "",
          "",
          setItemList,
          currentItemsPage,
          setTotalItemsPage
        );
      }
    });
  }, []);

  const onChangePagination = (page) => {
    setCurrentItemPage(page);
    GetListItemMaster(
      prefix,
      sectionName,
      token,
      dispatch,
      "",
      "",
      setItemList,
      page,
      setTotalItemsPage
    );
  };
  const onClickPrintBill = async (bill) => {
    if (bill) {
      setPrintData(bill);
    }

    setViewBillStatus(true);
  };
  const isMobileTypeScreen = width < 500;

  useEffect(() => {
    if (billCartList.find((b) => b.QNTY === 0)) {
      setIsRemove0Active(false);
    }
  }, [billCartList]);

  return (
    <div
      style={{
        backgroundColor: "#edf2f9" /* light gray */,
      }}
      className="  h-full  text-black flex  text-sm w-full"
    >
      <ItemSelectModal
        open={itemHelpStatus}
        onClose={() => {
          setItemHelpStatus(false);
        }}
        accountdetails={accountdetails}
        itemSearchText={itemSearchText}
        onSubmit={(items) => {
          items.map((i) => {
            itemClick(
              i,
              i,
              setBillCartList,
              billingDetails,
              customerDetails,
              i.ORDER_QNTY === 0 ? "ZERO" : i.ORDER_QNTY,
              dispatch,
              setAlertTwoButtonModal,
              true,
              "",
              "",
              "",
              false,
              profileSetting,
              billCartList,
              orderType
            );
          });
        }}
      />
      <OrderReceiptModal
        open={viewBillStatus}
        printData={printData}
        onClose={() => setViewBillStatus(false)}
      />
      {!isMobileTypeScreen && (
        <div className="h-full p-2 flex w-full">
          <div className="h-full">
            <BillNoComp
              setBillHelpStatus={setBillHelpStatus}
              billCartList={billCartList}
              date={date}
              profileSetting={profileSetting}
              dispatch={dispatch}
              setSettingModalStatus={setSettingModalStatus}
              setOrdertype={setOrdertype}
              orderType={orderType}
              setListAccountMasterHelp={setListAccountMasterHelp}
              accountdetails={accountdetails}
              setIsRemove0Active={setIsRemove0Active}
              isRemove0Active={isRemove0Active}
              setBillCartList={setBillCartList}
              setAlertTwoButtonModal={setAlertTwoButtonModal}
              setAccountDetails={setAccountDetails}
            />
            <div className="mt-1">
              {searchItemInput(
                searchBoxRef,
                searchRef,
                width,
                setBarCodeScannerStatus,
                itemSearchText,
                billCartList,
                dispatch,
                setBillCartList,
                billingDetails,
                customerDetails,
                setAlertTwoButtonModal,
                isStockCheck,
                setSearchQnty,
                setItem_Box,
                setSalePriceModalStatus,
                setItemSearchText,
                prefix,
                token,
                setItemList,
                setSectionName,
                profileSetting,
                true,
                setItemHelpStatus,
                accountdetails,
                orderType
              )}
            </div>
            <div
              style={{
                height: `calc(100% - ${
                  width >= 1024 ? 168 + 37 + 70 : 250 + 37 + 70
                }px)`,
                width: c.reduce((acc, row) => acc + Number(row.width), 0),
              }}
              className="mt-2 shadow-sm rounded-sm  overflow-hidden "
            >
              {billCart(c, billCartList, dispatch, setBillCartList)}
            </div>
            {totalQntyComponent(
              c,
              TotalQnty,
              totalReturn,
              billCartList,
              TotalAmount,
              totalReturnAmount,
              width,
              grandTotalWithTax,
              false,
              dispatch,
              isRemove0Active,
              setIsRemove0Active,
              setAlertTwoButtonModal,
              setBillCartList
            )}
          </div>
          <div className="flex  grow h-full   ">
            <div className="w-full h-full ">
              <div
                style={{
                  height: `calc(100% - 80px)`,
                }}
                className="flex w-full "
              >
                <SectionlistUI
                  sectionList={sectionList}
                  sectionName={sectionName}
                  setSectionName={setSectionName}
                  prefix={prefix}
                  token={token}
                  setBillCartList={setBillCartList}
                  dispatch={dispatch}
                  profileSetting={profileSetting}
                  billCartList={billCartList}
                  setAlertTwoButtonModal={setAlertTwoButtonModal}
                  customerDetails={customerDetails}
                  billingDetails={billingDetails}
                  currentItemsPage={currentItemsPage}
                  setTotalItemsPage={setTotalItemsPage}
                  setItemList={setItemList}
                  setCurrentItemPage={setCurrentItemPage}
                  accountdetails={accountdetails}
                  orderType={orderType}
                />
              </div>

              <div
                style={{
                  justifyContent:
                    width >= 1400 ? "space-between" : "space-between",
                  // backgroundColor: "#e0e5ec", // Light gray background
                  // boxShadow:
                  //   "inset 8px 8px 15px #c8d1e3, inset -8px -8px 15px #ffffff", // Inset shadow for neumorphism effect
                }}
                className="  pt-2 px-2"
              >
                <div className=" items-center grid grid-cols-3 gap-2 w-fit">
                  <div className="w-fit">
                    <button
                      onClick={async () => {
                        onBillSave(
                          billCartList,
                          dispatch,
                          prefix,
                          token,
                          Undo,
                          grandTotalWithTax,
                          setBillNo,
                          setAlertTwoButtonModal,
                          setViewBillStatus,
                          inputFields,
                          SaleType,
                          "",
                          "",
                          longitude,
                          latitude,
                          false,
                          customerDetails,
                          setIsOriginalBill,
                          roundOffAmt,
                          location?.state?.INVNO,
                          naviagte,
                          setPrintData,
                          onClickPrintBill
                        );
                      }}
                      className="bg-orange px-2 w-full py-2 rounded-lg whitespace-nowrap  items-center justify-center transform hover:scale-105 transition-all duration-300 ease-in-out"
                    >
                      <i className="bi	bi-box-seam text-xl "></i>
                      <div>Save Order</div>
                    </button>
                  </div>

                  <div>
                    <button
                      onClick={() => {
                        Undo();
                        setPrintData([]);
                      }}
                      className="bg-brown  px-2 py-2 w-full rounded-lg  items-center justify-center  text-white transform hover:scale-105 transition-all duration-300 ease-in-out"
                    >
                      <i className="bi bi-arrow-counterclockwise text-xl "></i>{" "}
                      <div>Undo</div>
                    </button>
                  </div>

                  {printData[0]?.ORDER_NO && (
                    <div>
                      <button
                        onClick={() => {
                          onClickPrintBill();
                        }}
                        className="bg-[#93C5FD] w-full text-black  px-2 py-2 rounded-lg  items-center justify-center transform hover:scale-105 transition-all duration-300 ease-in-out"
                      >
                        <i className="bi bi-printer text-xl"></i>
                        <div>Print Bill</div>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isMobileTypeScreen && (
        <MobileStockOrdering
          searchBoxRef={searchBoxRef}
          searchRef={searchRef}
          width={width}
          Undo={Undo}
          setRemarksStatus={setRemarksStatus}
          setBillNo={setBillNo}
          naviagte={naviagte}
          setViewBillStatus={setViewBillStatus}
          itemList={itemList}
          itemImgList={itemImgList}
          sectionName={sectionName}
          sectionList={sectionList}
          date={date}
          setAccountDetails={setAccountDetails}
          isRemove0Active={isRemove0Active}
          setIsRemove0Active={setIsRemove0Active}
          accountdetails={accountdetails}
          setListAccountMasterHelp={setListAccountMasterHelp}
          setOrdertype={setOrdertype}
          setSettingModalStatus={setSettingModalStatus}
          setBillHelpStatus={setBillHelpStatus}
          GetListItemMaster={GetListItemMaster}
          setBarCodeScannerStatus={setBarCodeScannerStatus}
          itemSearchText={itemSearchText}
          billCartList={billCartList}
          currentItemsPage={currentItemsPage}
          dispatch={dispatch}
          onChangePagination={onChangePagination}
          totalItemsPage={totalItemsPage}
          setTotalItemsPage={setTotalItemsPage}
          setBillCartList={setBillCartList}
          billingDetails={billingDetails}
          customerDetails={customerDetails}
          setAlertTwoButtonModal={setAlertTwoButtonModal}
          isStockCheck={isStockCheck}
          setSearchQnty={setSearchQnty}
          setItem_Box={setItem_Box}
          setSalePriceModalStatus={setSalePriceModalStatus}
          setItemSearchText={setItemSearchText}
          prefix={prefix}
          token={token}
          setIsSectionDraweropen={setIsSectionDraweropen}
          setItemList={setItemList}
          setSectionName={setSectionName}
          isSectionDrawerOpen={isSectionDrawerOpen}
          profileSetting={profileSetting}
          orderType={orderType}
        />
      )}

      <SnackbarProvider
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        maxSnack={2}
        autoHideDuration={1000}
      />

      <AccountMasterHelp
        onRowClick={(p) => {
          setListAccountMasterHelp(false);
          setAccountDetails(p.row);
          GetListItemMaster(
            prefix,
            "",
            token,
            dispatch,
            "",
            "",
            setItemList,
            currentItemsPage,
            setTotalItemsPage,
            p.row,
            orderType
          ).then((res) => {
            res.map((o) => {
              itemClick(
                o,
                o,
                setBillCartList,
                billingDetails,
                customerDetails,
                o.ORDER_QNTY === 0 ? "ZERO" : o.ORDER_QNTY,
                dispatch,
                setAlertTwoButtonModal,
                true,
                "",
                "",
                "",
                false,
                profileSetting,
                billCartList,
                orderType
              );
            });
          });
        }}
        onClose={() => {
          setListAccountMasterHelp(false);
        }}
        status={listAccountMasterHelp}
      />

      <ModNumericKeyboard
        onChange={(e) => {
          editBillFields(
            e,
            setBillCartList,
            dispatch,
            billCartList,
            billingDetails,
            customerDetails,
            setAlertTwoButtonModal,
            setBillingDetails,
            profileSetting,
            setCustomerDetails
          );
        }}
        editType={""}
        mode={"dark"}
        extraButtons={
          <button
            onClick={() => {
              if (issueItemDetails) {
                setAlertTwoButtonModal({
                  title: "Alert",
                  msg: "Are you sure for remove this item?",
                  button1: "Yes",
                  button2: "Cancel",
                  status: true,

                  button1Click: () => {
                    setAlertTwoButtonModal((o) => {
                      return {
                        ...o,
                        status: false,
                      };
                    });

                    setBillCartList((e) => {
                      const data = e.filter(
                        (i) => i.ICODE !== issueItemDetails.id
                      );
                      deleteWholeDatabase("billing").then(() => {
                        dataToLocal("billing", data, [
                          {
                            ICODE: 1,
                          },
                        ]);
                      });
                      return data;
                    });
                    dispatch(setnumericKeyboardStatus(false));
                    setAlertTwoButtonModal((e) => {
                      return {
                        ...e,
                        status: false,
                      };
                    });
                  },
                  button2Click: () => {
                    setAlertTwoButtonModal((o) => {
                      return {
                        ...o,
                        status: false,
                      };
                    });
                  },
                });
              }
            }}
            className="bg-[#242323] mt-2  rounded-sm  flex w-full justify-center text-red-500 py-1"
          >
            Remove Item
          </button>
        }
      />
      <BillingSettingsModal
        open={settingModalStatus}
        onClose={() => {
          setSettingModalStatus(false);
        }}
        onClickPrintBill={onClickPrintBill}
        printData={printData}
      />
      <BarcodeScanner
        onChange={(e) => {
          setItemSearchText(e);
          setBarCodeScannerStatus(false);
          GetListItemMaster(
            prefix,
            "",
            token,
            dispatch,
            "",
            () => {},
            () => {},
            1,
            () => {},
            accountdetails,
            orderType,
            "",
            "",
            "",
            e
          )
            .then((list) => {
              if (list[0]) {
                itemClick(
                  list[0],
                  list[0],
                  setBillCartList,
                  billingDetails,
                  customerDetails,
                  1,
                  dispatch,
                  setAlertTwoButtonModal,
                  false,
                  isStockCheck,
                  prefix,
                  token,
                  false,
                  profileSetting,
                  billCartList
                );
                setItemSearchText("");
              }
            })
            .finally(() => {
              dispatch(setSpinnerLoading(false));
            });
        }}
        setStatus={setBarCodeScannerStatus}
        status={barCodeCannerStatus}
      />
      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />

      <StockHelp
        onRowClick={(p) => {
          LoadBill(
            prefix,
            token,
            dispatch,
            p.row.ORDER_NO,
            setBillCartList,
            setCustomerDetails,
            setBillingDetails,
            setDate,
            bill_performa,
            false,
            setPrintData
          ).then((l) => {
            setPrintData(l);
          });
          setIsHoldButonShow(false);
          setBillHelpStatus(false);
        }}
        status={billHelpStatus}
        onClose={() => setBillHelpStatus(false)}
      />

      {remarksStatus && (
        <ItemInstructionModal
          remarksStatus={remarksStatus}
          setRemarksStatus={setRemarksStatus}
          remarks={remarks}
          title={"About order"}
          placeHolder={"Remarks"}
          setRemarks={setRemarks}
          previosInstruction={previosInstruction}
          onFocus={() => {
            setisTextActive(true);
          }}
          selectedItem={selectedItem}
          billCartList={billCartList}
          onBlur={() => {
            setisTextActive(false);
          }}
          onSave={() => {
            setRemarksStatus(false);
            setBillCartList((o) => {
              return o.map((or) => {
                if (or.ICODE === selectedItem) {
                  return {
                    ...or,
                    ITEM_INSTRUCTIONS: remarks,
                  };
                } else {
                  return or;
                }
              });
            });

            const isDuplicate = previosInstruction.filter(
              (o) => o.toLowerCase() === remarks.toLowerCase()
            );
            if (!isDuplicate[0]) {
              localStorage.setItem(
                "item_instruction",
                JSON.stringify([...previosInstruction, remarks])
              );
            }

            setRemarks("");
          }}
          buttonName={"Save"}
        />
      )}
    </div>
  );
};

export default StockOrdering;
